// src/equipe.ts
var SIEGES_PAR_DEFAUT = 10;
var JOURS_INVITATION = 14;
var MODULE_MARQUE_ORGANISATION = "marque-organisation";
function estAdministrateur(role) {
  return role === "admin" || role === "owner";
}
function libelleNiveau(role) {
  if (estAdministrateur(role)) return "Administrateur";
  if (role === "analyst") return "Lance des \xE9tudes";
  return "Consulte";
}
function ecritureAcces(demande, ctx) {
  if (demande.type === "administrateur") {
    return {
      ok: true,
      ecriture: { role: ctx.roleActuel === "owner" ? "owner" : "admin", role_id: null, modules: null }
    };
  }
  if (demande.type === "role") {
    const r = ctx.roles.find((x) => x.id === demande.role_id);
    if (r === void 0) {
      return { ok: false, code: "role_inconnu", message: "Ce r\xF4le n\u2019existe pas dans votre organisation." };
    }
    const niveau = r.level === "viewer" ? "viewer" : "analyst";
    return { ok: true, ecriture: { role: niveau, role_id: r.id, modules: null } };
  }
  const verif = modulesPermis(demande.modules, ctx.modulesOrganisation);
  if (!verif.ok) return verif;
  if (verif.modules.length === 0) {
    return { ok: false, code: "aucun_module", message: "Choisissez au moins un module." };
  }
  return {
    ok: true,
    ecriture: { role: demande.peut_lancer ? "analyst" : "viewer", role_id: null, modules: verif.modules }
  };
}
function modulesPermis(demandes, modulesOrganisation) {
  const voulus = new Set(demandes.map((m) => m.trim()).filter((m) => m !== ""));
  const horsOrganisation = [...voulus].filter((m) => !modulesOrganisation.includes(m));
  if (horsOrganisation.length > 0) {
    return {
      ok: false,
      code: "module_hors_organisation",
      message: `Votre organisation n\u2019a pas acc\xE8s \xE0 : ${horsOrganisation.join(", ")}.`
    };
  }
  return { ok: true, modules: modulesOrganisation.filter((m) => voulus.has(m)) };
}
function retireLeDernierAdministrateur(membres, userId, nouveauRole) {
  const reels = membres.filter((m) => m.is_platform_superadmin !== true);
  const avant = reels.filter((m) => estAdministrateur(m.role));
  const cible = reels.find((m) => m.user_id === userId);
  if (cible === void 0 || !estAdministrateur(cible.role)) return false;
  if (nouveauRole !== null && estAdministrateur(nouveauRole)) return false;
  return avant.length <= 1;
}
function manquesMotDePasse(mdp) {
  const manques = [];
  if (mdp.length < 12) manques.push("12 caract\xE8res");
  if (!/[a-z]/.test(mdp)) manques.push("une minuscule");
  if (!/[A-Z]/.test(mdp)) manques.push("une majuscule");
  if (!/[0-9]/.test(mdp)) manques.push("un chiffre");
  if (!/[^A-Za-z0-9]/.test(mdp)) manques.push("un symbole");
  return manques;
}
function normaliserEmail(brut) {
  const e = brut.trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) ? e : null;
}
export {
  JOURS_INVITATION,
  MODULE_MARQUE_ORGANISATION,
  SIEGES_PAR_DEFAUT,
  ecritureAcces,
  estAdministrateur,
  libelleNiveau,
  manquesMotDePasse,
  modulesPermis,
  normaliserEmail,
  retireLeDernierAdministrateur
};
